module.exports = __webpack_public_path__ + "static/media/Eric.497fad88.png";